import { render, staticRenderFns } from "./g-task-loading.vue?vue&type=template&id=84ee89a8&scoped=true&"
import script from "./g-task-loading.vue?vue&type=script&setup=true&lang=ts&"
export * from "./g-task-loading.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./g-task-loading.vue?vue&type=style&index=0&id=84ee89a8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ee89a8",
  null
  
)

export default component.exports